const API_BASE = import.meta.env.VITE_API_URL || '';

export function log(action: string, context?: Record<string, unknown>) {
  const payload = {
    action,
    context: context || {},
    timestamp: new Date().toISOString(),
    page_url: window.location.pathname,
  };

  // Use sendBeacon for fire-and-forget (survives page unload)
  const sent = navigator.sendBeacon(
    `${API_BASE}/api/activity`,
    JSON.stringify(payload)
  );

  // Fallback to fetch if sendBeacon fails
  if (!sent) {
    fetch(`${API_BASE}/api/activity`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      credentials: 'include',
      keepalive: true,
    }).catch(() => {});
  }
}
